(() => {
    document.addEventListener("DOMContentLoaded", function () {

        const $get = id => document.getElementById(id);

        const newTable = $get("mainTable");

        const tJsonW = $get("JSONRoadType") as HTMLTextAreaElement; 
        let roadTypes = JSON.parse(tJsonW.value);

        const tJsonTitle = $get("JSONTitle") as HTMLTextAreaElement;
        const titleData = JSON.parse(tJsonTitle.value);

        const tJson = $get("JSONData") as HTMLTextAreaElement;
        const compactionData = tJson.value;
        
        const allData = JSON.parse(compactionData);

        const container = $get("mainTable");

        let innerHTML = `
            
            <div class="row align-items-left mt-1" style="text-indent: 0px">
                <div class="col mt-2 w-auto" style="line-height:1.7em">
                    <label for="">Select road type(s):</label><br />
                
                        `;

        let cb = 0;
        roadTypes.forEach((x) => {
            innerHTML += `<label for="ww${cb}"><input style="margin-left: 45px; margin-right:10px" type="checkbox" name="ww${cb}" id="ww${cb}" class="lValue" value="${x}" /><b>${x}</b></label><br />`
            cb += 1;
        }
        );

        innerHTML += `
                    
               </div>
            </div>
            <div class="row mt-2" style="text-indent: 0px">
                <div class="form-group col-lg-7 mt-1">
                    <button id="btnShowRequirements"
                                name="command"
                                value="search"
                                type="submit"
                                class="ml-1  btn btn-primary">
                            Show requirements
                    </button>
<!-- &nbsp;
<a class="btn btn-primary" href="/sroh-road-categories-old-table" id="btnShowOriginalTable" role="button">Show full table</a> -->
                </div>
           </div>

            <div id="tblRequirements" class="mt-1"></div>
        `

        container.innerHTML = innerHTML;


        const btnShowRequirementsClick = function (event) {

            const dataRow = allData[0];

            const lValues: string[] = [];

            $("input:checkbox[class=lValue]:checked").each(function () {
                lValues.push(String($(this).val()));
            });

            const invalidSelection = lValues.length === 0;

            if (!invalidSelection) {
                

                let txt = `
<style>

table.table-sroh td {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
}

table.table-sroh td:first-child {
    border-left: none;
}

table.table-sroh td:last-child {
    border-right: none;
}

table.table-sroh th {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    border-top: 1px solid #000;
}

table.table-sroh th:first-child {
    border-left: none;
}

table.table-sroh th:last-child {
    border-right: none;
}


table.table-sroh caption {
    font-weight: bold;
    font-size: 1.2em;
    caption-side: top;
}


table.table-sroh tr.border-bottom, table.table-sroh td.border-bottom {
    border-bottom: 1px solid #000 !important;
}

table.table-sroh tr.shaded, table.table-sroh td.shaded, table.table-sroh th.shaded {
 background-color: #E5EEFD;
}

tr.partition td,  tr.partition th {
    border-top: 2px solid black;
}

td, th {
    text-align: center;
}
</style>
        <table role="table" class="table table-responsive table-sroh mt-2" style="margin-left:-2em">
        <caption>${titleData.Title}</caption>
            <thead>
            <tr>
                <th class="shaded" rowspan="2" style="width:10%; vertical-align:top">Year of traffic count</th>
                <th class="shaded" colspan="${lValues.length}" vertical-align:top">Daily traffic flow - Commercial vehicles/day one direction - Single or dual carriageway</th>
                <th class="shaded" rowspan="2" style="width:10%; vertical-align:top">Average growth rate %</th>
            </tr>

            <tr>`
                lValues.forEach((x) =>
                    txt += `<th class="shaded">${x}</th>`
                );

                txt += `
            </tr>
            </thead>
            <tbody>`
           
                for (let n = 0; n < 9; n++) {
                    txt += processTableBlock(n, lValues, dataRow);
                }

                txt += `</tbody>

            <tfoot>
            <tr class="border-bottom partition">
            <td colspan="${lValues.length + 2}">
                <strong>Note:</strong> The datum for year 0 is the time of the reinstatement
            </td>
            </tr>
            </tfoot>

            
            </table>
            `;

               // render the table... 

                $get("tblRequirements").innerHTML = txt;

            }
            else {
                $get("tblRequirements").innerHTML = "";
            }
        };


        const processTableBlock = function (index, lValues, dataRow) {
            let txt = `<tr class="border-bottom partition">
            <th>0</th>`
            lValues.forEach((x) =>
                txt += `<td>${dataRow[index].find(i => i.key === x).value[0]}</td>`
            );

            txt += `
            <td rowspan="5" style="vertical-align:middle">${index}</td>
            </tr>


            <tr class="border-bottom">
            <th>5</th>`
            lValues.forEach((x) =>
                txt += `<td>${dataRow[index].find(i => i.key === x).value[1]}</td>`
            );

            txt += `
            </tr>

            <tr class="border-bottom">
            <th>10</th>`
            lValues.forEach((x) =>
                txt += `<td>${dataRow[index].find(i => i.key === x).value[2]}</td>`
            );

            txt += `
            </tr>

            <tr class="border-bottom">
            <th>15</th>`
            lValues.forEach((x) =>
                txt += `<td>${dataRow[index].find(i => i.key === x).value[3]}</td>`
            );

            txt += `
            </tr>

            <tr class="border-bottom">
            <th>20</th>`
            lValues.forEach((x) =>
                txt += `<td>${dataRow[index].find(i => i.key === x).value[4]}</td>`
            );

            txt += `
            </tr>`
            return txt;
        }



        $get("btnShowRequirements").addEventListener("click", btnShowRequirementsClick);

    });

})();
